module.exports = __webpack_public_path__ + "9ce066d92bb6572b5093d80ef5437edc.jpg";


//////////////////
// WEBPACK FOOTER
// ../img/placeholder-2.jpg
// module id = 481
// module chunks = 0